import { InnerText, TopBarContainer } from "./top-bar.style"

const TopBar = () => {
    return (
     <TopBarContainer>
        <InnerText> *New User? Get 15% OFF on your First Order.</InnerText>
     </TopBarContainer>
    )
}

export default TopBar